export class EarthPressuresCalculation {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.modelSection = modelSection ?? null;
        this.intervals = data.intervals ?? [];
        this.pressures = data.pressures ?? [];

    }

}
